import type { ButtonProps } from '@mui/material'
import MuiButton from '@mui/material/Button'
import { forwardRef } from 'react'

type Variant = 'primary' | 'secondary' | 'tertiary'

type Props = Omit<ButtonProps, 'variant'> & {
  loading?: boolean
  variant?: Variant
  component?: string
}

const Button = forwardRef((props: Props, _) => {
  const { variant = 'primary', sx, ...buttonProps } = props

  // @ts-expect-error showLabel prop gives error on DOM
  delete buttonProps.showLabel

  const roundedSx = { borderRadius: '1240px', ...sx }

  switch (variant) {
    case 'primary':
      return (
        <MuiButton {...buttonProps} sx={roundedSx} variant="contained">
          {props.children}
        </MuiButton>
      )

    case 'secondary':
      return (
        <MuiButton
          {...buttonProps}
          sx={{ borderWidth: '2px', ...roundedSx }}
          variant="outlined"
        >
          {props.children}
        </MuiButton>
      )

    case 'tertiary':
      return (
        <MuiButton
          {...buttonProps}
          sx={roundedSx}
          variant="text"
          color="secondary"
        >
          {props.children}
        </MuiButton>
      )

    default:
      throw new Error(`Invalid button variant`)
  }
})

export default Button
